/*  useCms — tiny hook + interpolator for DB-driven page content.
    ────────────────────────────────────────────────────────────────
    Every public page hits `/api/landing/cms/{page}` on mount and gets a
    flat lookup dict. Components use `t(key, fallback)` to render a
    string, degrading to the fallback if the key hasn't loaded yet or
    doesn't exist. Mustache-style `{token}` values are interpolated via
    the returned helper.
*/
import { useEffect, useState } from "react";
import api from "@/lib/api";


export function interpolate(str, values) {
    if (!str) return "";
    return String(str).replace(/\{(\w+)\}/g, (m, k) => (values && values[k] != null ? String(values[k]) : m));
}


export function useCms(page) {
    const [cms, setCms] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        api.get(`/landing/cms/${page}`)
            .then((r) => { if (!cancelled) setCms(r.data?.cms || {}); })
            .catch(() => { if (!cancelled) setCms({}); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [page]);

    /* Look up a key by short or full dot-notation. Fallback preserves
       the pre-CMS copy so the page never renders empty during loading
       or on API failure. */
    const t = (key, fallback = "") => (cms[key] ?? cms[`${page}.${key}`] ?? fallback);

    return { cms, t, loading };
}
